import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import xBitcoinIcon from '../../../assets/updated/smartCrypto/x-bitcoin.png';
import xBlueIcon from '../../../assets/updated/smartCrypto/x-blue.png';
import { useSearchParams } from 'react-router-dom';
import bloomingIcon from '../../../assets/updated/smartCrypto/blomming.png';
import rushIcon from '../../../assets/updated/smartCrypto/rush.png';
import bullRunIcon from '../../../assets/updated/smartCrypto/bullrun.png';

import ripple from '../../../assets/updated/smartCrypto/ripple.png';
import surge from '../../../assets/updated/smartCrypto/surge.png';
import wave from '../../../assets/updated/smartCrypto/Wave.png';

import { Avatar, AvatarGroup } from '@mui/material';
import GenericButton from '../shared/Button';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../Hooks/useAuth';
import LoginRequiredPopup from '../shared/LoginRequiredPopup';

import {
  createSmartCryptoSubscription,
  decodeJWT,
  getSmartCryptoPackages,
  getSmartCryptoSubscriptionPlans,
  removeTokens,
  baseURL,
} from '../../../services/api';
import Inex from '../../../assets/updated/buySell/INEX.svg';
import initialTokens from '../../../utils/Tokens.json';
import AllocationPopup from './AllocationPopup';
import CreateAPlanPopup from './CreateAPlan';
import CreateOwnPlan from './CreateOwnPlan';
import IconicHeader from '../shared/IconicHeader';
import plusIcon from '../../../assets/updated/smartCrypto/plusIcon.svg';
import DetailPopup from './DetailPopup';
import xBlueBg from '../../../assets/updated/smartCrypto/x-bluebg.png';
import xBitcoinBg from '../../../assets/updated/smartCrypto/x-Bitcoinbg.png';
import PlanIconicHeader from '../Assets/PlanIconicHeader';
import DemoInvestmentPopup2 from './DemoInvestmentPopup2';
import PaymentPopup from './PaymentPopup';
import CloseIcon from '@mui/icons-material/Close';
import GeneralPopup from '../BuySell/Popup';
const useStyles = makeStyles((theme) => ({
  root: {
    margin: '0 auto',
    paddingTop: '100px',
    [theme.breakpoints.down('md')]: {
      paddingTop: '80px',
    },
  },
  header: {
    maxWidth: '1280px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px',
    margin: '0 auto 30px auto',
  },
  headerIconContainer: {
    display: 'flex',
    gap: '5px',
    justifyContent: 'center',
    marginBottom: '20px',
    alignItems: 'center',
    transition: 'all .3s linear',
    cursor: 'pointer',
    '& img': {
      height: '70px',
    },
    '& p': {
      fontSize: '24px',
      fontWeight: '500',
      fontStyle: 'italic',
    },
    '&:hover': {
      transform: 'scale(1.1)',
      transition: 'all .3s linear',
    },
  },
  cardWrapper: {
    maxWidth: '1280px',
    width: '100%',
    display: 'flex',
    margin: 'auto',
    justifyContent: 'center',
    padding: '10px',
    gap: '10px',
    flexWrap: 'wrap',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },

  cardContainer: {
    border:
      theme.palette.mode === 'dark'
        ? '1px solid rgb(71, 77, 87)'
        : `1px solid ${theme.palette.divider}`,
    width: '32.7%',
    background: theme.palette.mode === 'dark' ? theme.palette.divider : '#fff',
    padding: '20px',
    display: 'flex',
    gap: '10px',
    margin: '0px',
    minWidth: 0,
    flexDirection: 'column',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
    '& h3': {
      fontSize: '16px',
      fontWeight: '500',
      color: theme.palette.text.primary,
      margin: '0px 0px 16px',
    },
  },
  flexContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  flexContainer1: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    transition: 'all .2s linear',
    cursor: 'pointer',
    '&:hover': {
      transform: 'scale(1.15)',
    },
    '& img': {
      height: '60px',
    },
    '& h2': {
      fontSize: '16px',
      fontWeight: '400',
      margin: 0,
    },
    margin: '0px 0px 20px 0px',
  },
  assetContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '10px',
  },
  assetsText: {
    fontSize: '14px',
    color: theme.palette.text.secondary,
    margin: '0px 0px 5px',
  },
  imgGroup: {},
  buttonContainer: {
    display: 'flex',
    gap: '10px',
    marginTop: 'auto',
  },
  subscriptionCallout: {
    marginTop: '12px',
    display: 'flex',
    justifyContent: 'center',
  },
  subscriptionInstruction: {
      margin: '20px auto 40px',
      padding: '16px 20px',
    maxWidth: '960px',
    borderRadius: '14px',
    border: `1px solid ${theme.palette.divider}`,
    background:
      theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : '#f4f4f6',
    color: theme.palette.text.primary,
    fontSize: '14px',
    lineHeight: 1.5,
  },
  monthlyCardsWrapper: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(260px, 1fr))',
    gap: '18px',
    width: '100%',
    marginTop: '24px',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(1, minmax(260px, 1fr))',
    },
  },
  detailInfoSection: {
    marginTop: '24px',
    padding: '16px',
    borderRadius: '14px',
    background:
      theme.palette.mode === 'dark'
        ? 'rgba(255,255,255,0.02)'
        : 'rgba(255,255,255,0.04)',
  },
  detailInfoList: {
    paddingLeft: '20px',
    marginTop: '12px',
    color: theme.palette.text.secondary,
  },
  detailInfoItem: {
    marginBottom: '6px',
  },
  detailInfoNote: {
    marginTop: '16px',
    fontSize: '12px',
    color: theme.palette.text.secondary,
  },
  monthlyPlansFooter: {
    marginTop: '24px',
  },
  subscriptionCard: {
    borderRadius: '16px',
    padding: '24px',
    minHeight: '220px',
    background:
      theme.palette.mode === 'dark'
        ? 'rgba(255,255,255,0.02)'
        : 'rgba(255,255,255,0.04)',
    border: `1px solid ${
      theme.palette.mode === 'dark'
        ? 'rgba(255,255,255,0.08)'
        : 'rgba(255,255,255,0.15)'
    }`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  subscriptionOverlay: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0,0,0,0.6)',
    zIndex: 1300,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
  },
  subscriptionModal: {
    width: '100%',
    maxWidth: '960px',
    borderRadius: '18px',
    background: theme.palette.background.paper,
    padding: '24px',
    maxHeight: '90vh',
    overflow: 'auto',
  },
  subscriptionModalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
  },
  subscriptionModalHero: {
    marginBottom: '18px',
    paddingBottom: '18px',
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  subscriptionHeroBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '6px 16px',
    borderRadius: '999px',
    background: '#FEBA00',
    color: '#000',
    fontWeight: 700,
    fontSize: '12px',
    marginBottom: '6px',
  },
  subscriptionHeroBranding: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    justifyContent: 'center',
    marginBottom: '12px',
  },
  subscriptionHeroLogo: {
    width: '48px',
    height: '48px',
    objectFit: 'contain',
  },
  subscriptionHeroBrandingText: {
    textAlign: 'left',
    '& p': {
      margin: 0,
    },
  },
  subscriptionHeroBrandingTitle: {
    fontSize: '18px',
    fontWeight: 700,
  },
  subscriptionHeroBrandingSubtitle: {
    fontSize: '14px',
    color: theme.palette.text.secondary,
  },
  subscriptionHeroTitle: {
    fontSize: '26px',
    fontWeight: 700,
    margin: '0 0 6px',
  },
  subscriptionHeroSubtitle: {
    margin: 0,
    color: theme.palette.text.secondary,
  },
  subscriptionCardTitle: {
    fontSize: '18px',
    fontWeight: 600,
  },
  subscriptionCardPrice: {
    fontSize: '42px',
    fontWeight: 700,
    color: '#FEBA00',
    margin: '16px 0 6px',
  },
  subscriptionCardPerMonth: {
    fontSize: '14px',
    letterSpacing: '1px',
    marginBottom: '12px',
  },
  subscriptionCardDescription: {
    fontSize: '12px',
    lineHeight: 1.6,
    marginBottom: '20px',
    color: theme.palette.text.secondary,
  },
  featuresSection: {
    marginTop: '32px',
  },
  featuresSectionTitle: {
    fontSize: '22px',
    fontWeight: 700,
    margin: 0,
  },
  featuresSectionSubTitle: {
    fontSize: '14px',
    color: theme.palette.text.secondary,
    marginTop: '4px',
  },
  featuresGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '18px',
    marginTop: '16px',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
    },
  },
  featureCard: {
    padding: '18px',
    borderRadius: '16px',
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-start',
    background:
      theme.palette.mode === 'dark'
        ? 'rgba(255,255,255,0.02)'
        : 'rgba(255,255,255,0.06)',
  },
  featureIcon: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    background: '#FEBA00',
  },
  featureText: {
    '& p': {
      margin: '0 0 4px',
    },
  },
  featureTitle: {
    fontSize: '16px',
    fontWeight: 600,
  },
  featureDescription: {
    fontSize: '13px',
    color: theme.palette.text.secondary,
  },
  greyButton: {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? `rgb(71, 77, 87) !important`
        : `${theme.palette.divider} !important`,
    color: `${theme.palette.text.primary} !important`,
  },
  yellowButton: {
    backgroundColor: `#FEBA00 !important`,
    color: `#000 !important`,
  },
  blueButton: {
    backgroundColor: `#07A6FC !important`,
    color: `#000 !important`,
  },
  createOwnPlan: {
    maxWidth: '1280px',
    width: '100%',
    margin: '100px auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '&>h3': {
      fontSize: '38px',
      textAlign: 'center',
    },
    '&>p': {
      textAlign: 'center',
      marginBottom: '50px',
    },
  },
  cardRoot: {
    maxWidth: '1280px',
    width: '100%',
    margin: '200px auto',
    '& h3': {
      fontSize: '48px',
      marginBottom: '20px',
      fontWeight: '500',
    },
    '& p': {
      fontSize: '14px',
      marginBottom: '50px',
    },
  },
  plusContainer: {
    position: 'absolute',
    width: '30px',
    height: '30px',
    bottom: 15,
    right: 15,
    display: 'flex',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItem: 'center',
    '&:hover': {
      opacity: 0.6,
    },
    '& img': {
      width: '100%',
      height: '100%',
    },
  },

  card: {
    background: theme.palette.divider,
    position: 'relative',
    padding: '20px',
    paddingBottom: '100px',
    flex: 1,
    maxWidth: '400px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    '& p': {
      flex: 1,
      fontSize: '18px',
    },
  },
  imgContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    '& img': {
      width: '70px',
    },
    '& span': {
      fontSize: '18px',
      fontWeight: 'bold',
      fontStyle: 'italic',
    },
  },
  smallCardContainer: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    marginTop: '25px',
  },
  smallCard: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignitems: 'center',
    textAlign: 'center',
    transition: 'all .2s linear',
    '&:hover': {
      '& > img': {
        transform: 'scale(1.05)',
        transition: 'all .2s linear',
      },
    },
  },
  blueSmCardHover: {
    '&:hover': {
      '& span': {
        color: '#08A6FD',
      },
    },
  },
  yellowSmCardHover: {
    '&:hover': {
      '& span': {
        color: '#FBB002',
      },
    },
  },
  cardContainerOne: {
    display: 'flex',
    justifyContent: 'center',

    gap: '20px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  exploreContainer: {
    position: 'relative',
    '& h3': {
      fontSize: '48px',
      marginBottom: '50px',
      fontWeight: '500',
      maxWidth: '1280px',
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  absoluteImg: {
    position: 'absolute',
    top: -50,
    right: 0,
    display: 'flex',
    justifyContent: 'flex-end',
    '& img': {
      width: '50%',
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  exploreBgContainer: {
    background: theme.palette.divider,
    padding: '50px',
  },
  contentContainer: {
    maxWidth: '1280px',
    width: '100%',
    margin: 'auto',
    display: 'flex',
    gap: '20px',
    '&>div': {
      maxWidth: '270px',
      width: '100%',
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  planCardRoot: {
    display: 'flex',
    flexDirection: 'column',
    background: theme.palette.divider,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '10px',
    padding: '10px',
    '& img': {
      height: '100px',
      width: '100px',
      margin: 'auto',
    },
    '& h4': {
      marginTop: '-10px',
      fontSize: '24px',
      fontWeight: 'bold',
    },
    '& p': {
      marginBottom: '40px',
      textAlign: 'center',
    },
  },
  cardDescription: {
    margin: '50px 0px',
    '& h4': {
      fontSize: '16px',
    },
  },
  flexContainertwo: {
    display: 'flex',
    gap: '100px',
    marginBottom: '10px',
  },
  activePlan: {
    transform: 'scale(1.15)',
  },
  activeBar: {
    width: '16px',
    height: '3px',
    background: theme.palette.text.primary,
    marginTop: '10px',
  },
}));

const getPlanLabel = (portfolioName) => {
  if (!portfolioName) return 'Smart Crypto plan';
  if (portfolioName.includes('Smart Crypto Ripple')) return 'x-Blue Ripple';
  if (portfolioName.includes('Smart Crypto Wave')) return 'x-Blue Wave';
  if (portfolioName.includes('Smart Crypto Surge')) return 'x-Blue Surge';
  if (portfolioName.includes('xBitcoin Blooming')) return 'x-Bitcoin Blooming';
  if (portfolioName.includes('xBitcoin Bull-Run')) return 'x-Bitcoin Bull-Run';
  if (portfolioName.includes('xBitcoin Rush')) return 'x-Bitcoin Rush';
  return portfolioName;
};

const getSubscriptionAmount = (pkg) => {
  if (!pkg) return 0;
  return (
    pkg.subscriptionAmount ??
    pkg.monthlyContribution ??
    pkg.amount ??
    pkg.minimumInvestment ??
    pkg.targetAmount ??
    pkg.price ??
    0
  );
};

const defaultMonthlySubscriptionPlans = [
  { _id: 'sub-300', portfolioName: 'Smart Crypto $300', subscriptionAmount: 300 },
  { _id: 'sub-500', portfolioName: 'Smart Crypto $500', subscriptionAmount: 500 },
  { _id: 'sub-1000', portfolioName: 'Smart Crypto $1000', subscriptionAmount: 1000 },
  { _id: 'sub-5000', portfolioName: 'Smart Crypto $5000', subscriptionAmount: 5000 },
];

const subscriptionFeatures = [
  {
    title: 'Model portfolio update',
    description:
      'A simple allocation plan across major assets with clear % weights and position sizing guidance.',
  },
  {
    title: 'Risk & rebalancing rules',
    description:
      'Rules for trimming, adding, and rebalancing during bull-run conditions—focused on discipline, not hype.',
  },
  {
    title: 'Educational walkthrough',
    description:
      'Plain-English rationale: what changed, why it changed, and what to watch next month.',
  },
  {
    title: 'Alerts (optional)',
    description:
      'Market regime and risk alerts (e.g., major trend breaks) so you can decide whether to de-risk.',
  },
];

const PlanDetails = () => {
  const classes = useStyles();
  const { name: names } = useParams();
  const navigate = useNavigate();
  const { showLoginPopup, handleLoginPopupClose, requireAuth } = useAuth();
  const handleTokenExpiryLogout = () => {
    const itemsToRemove = [
      'user',
      'access_token',
      'refresh_token',
      'userType',
      'username',
      'userlogged',
      'redirected',
      'email',
    ];
    itemsToRemove.forEach((item) => localStorage.removeItem(item));
    window.location.href = `${baseURL}/auth/login?action=Logout`;
  };
  const [category, setCategory] = useState();
  const [details, setDetails] = useState({});
  const [filteredPackages, setFilteredPackages] = useState([]);
  const [packagesData, setPackagesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedAllocation, setSelectedAllocation] = useState(null);
  const [allocationPopop, setAllocationPopup] = useState(false);
  const [createAPlanPopop, setCreateAPlanPopup] = useState(false);
  const [allTokens, setAllTokens] = useState([]);
  const [createOwnPlan, setCreateOwnPlan] = useState(false);
  const [selectedTab, setSelectedTab] = useState('Smart Crypto');
  const [selectedCategory, setSelectedCategory] = useState();
  const [planDetailPopupOpen, setPlanDetailPopupOpen] = useState(false);
  const [selectedPlanName, setSelectedPlanName] = useState('');
  const [selectedPlanTab, setSelectedPlanTab] = useState(
    names === 'ripple' || names === 'surge' || names === 'wave' ? 0 : 1
  );
  const [searchParams] = useSearchParams();
  const isWebinarUser = searchParams.get('isWebinarUser') === 'true';
  const isFreeTrialUpgrade = searchParams.get('isFreeTrialUpgrade') === 'true';
  const [showDemoPopup2, setShowDemoPopup2] = useState(false);
  const [subscriptionPopupOpen, setSubscriptionPopupOpen] = useState(false);
  const [subscriptionPackage, setSubscriptionPackage] = useState(null);
  const [subscriptionPlanLabel, setSubscriptionPlanLabel] = useState('');
  const [subscriptionMethodMessage, setSubscriptionMethodMessage] = useState('');
  const [subscriptionSelectorOpen, setSubscriptionSelectorOpen] = useState(false);
  const [subscriptionPlans, setSubscriptionPlans] = useState(
    defaultMonthlySubscriptionPlans
  );
  const [subscriptionPlansLoading, setSubscriptionPlansLoading] = useState(true);
  const [subscriptionPlanError, setSubscriptionPlanError] = useState('');
  const [tokenExpiredPopupOpen, setTokenExpiredPopupOpen] = useState(false);
  const [tokenExpiredMessage, setTokenExpiredMessage] = useState('');
  

  useEffect(() => {
    if (isWebinarUser) {
      console.log('Webinar user detected! Apply webinar-specific logic here.');
    }
  }, [isWebinarUser]);

  useEffect(() => {
    if (!tokenExpiredPopupOpen) {
      return;
    }

    const timer = setTimeout(() => {
      setTokenExpiredPopupOpen(false);
      handleTokenExpiryLogout();
    }, 10000);

    return () => clearTimeout(timer);
  }, [tokenExpiredPopupOpen]);

  const [name, setName] = useState(names);

  const xBluePlan = [
    {
      img: ripple,
      name: 'Ripple',
    },
    {
      img: surge,
      name: 'Surge',
    },
    {
      img: wave,
      name: 'Wave',
    },
  ];

  const xBitcoinPlan = [
    {
      img: bloomingIcon,
      name: 'Blooming',
    },
    {
      img: rushIcon,
      name: 'Rush',
    },
    {
      img: bullRunIcon,
      name: 'Bull-Run',
    },
  ];

  const selectedPlan = category === 'x-Blue' ? xBluePlan : xBitcoinPlan;

  useEffect(() => {
    let getRequiredCoin = initialTokens.filter(
      (x) => x.commonToken === true && x.isStock === false && x.isETF === false
    );
    setAllTokens(getRequiredCoin);
  }, []);

  useEffect(() => {
    let mounted = true;
    const fetchPlans = async () => {
      if (!mounted) return;
      setSubscriptionPlansLoading(true);
      setSubscriptionPlanError('');
      try {
        const response = await getSmartCryptoSubscriptionPlans();
        const payload =
          response?.data?.plans ??
          response?.data ??
          response?.plans ??
          response ??
          [];
        const normalizedPlans = Array.isArray(payload) ? payload : [];
        if (normalizedPlans.length) {
          if (mounted) {
            setSubscriptionPlans(normalizedPlans);
          }
        } else if (mounted) {
          setSubscriptionPlanError(
            'The subscription tiers could not be updated right now. Showing the default options.'
          );
        }
      } catch (error) {
        console.error('Error loading subscription plans', error);
        if (mounted) {
          setSubscriptionPlanError(
            'Unable to load subscription plans right now. Please try again later.'
          );
        }
      } finally {
        if (mounted) {
          setSubscriptionPlansLoading(false);
        }
      }
    };

    fetchPlans();
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    console.log(name, 'name');
    if (name === 'blooming') {
      setCategory('x-Bitcoin');
      // setSelectedPlanTab(1);
      setDetails({
        name: 'Blooming',
        logo: bloomingIcon,
        description: ' Optimized for low volatility and steady performance.',
      });
    } else if (name === 'rush') {
      setCategory('x-Bitcoin');
      // setSelectedPlanTab(1);
      setDetails({
        name: 'Rush',
        logo: rushIcon,
        description: ' Moderate volatility, consistent returns.',
      });
    } else if (name === 'bull-run') {
      setCategory('x-Bitcoin');
      // setSelectedPlanTab(1);
      setDetails({
        name: 'Bull-Run',
        logo: bullRunIcon,
        description: ' High volatility, high potential returns.',
      });
    } else if (name === 'ripple') {
      setCategory('x-Blue');
      // setSelectedPlanTab(0);
      setDetails({
        name: 'Ripple',
        logo: ripple,
        description: '  Designed for stability and stable returns.',
      });
    } else if (name === 'surge') {
      setCategory('x-Blue');
      // setSelectedPlanTab(0);

      setDetails({
        name: 'Surge',
        logo: surge,
        description: '  Moderate volatility, consistent returns.',
      });
    } else if (name === 'wave') {
      setCategory('x-Blue');
      // setSelectedPlanTab(0);

      setDetails({
        name: 'Wave',
        logo: wave,
        description: 'High volatility, high rewards.',
      });
    }

    setPlanDetailPopupOpen(false);
  }, [name]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getSmartCryptoPackages();
        // Sort by subTitle (assuming subTitle is a string)
        const sortedData = (response.data || []).sort((a, b) =>
          a.subTitle.localeCompare(b.subTitle)
        );

        // Category-based filtering logic
        const categoryFilters = {
          'x-Blue': [
            'Smart Crypto Ripple',
            'Smart Crypto Surge',
            'Smart Crypto Wave',
          ],
          'x-Bitcoin': [
            'xBitcoin Blooming',
            'xBitcoin Bull-Run',
            'xBitcoin Rush',
          ],
        };

        console.log('sortedData', sortedData);
        const applicableNames = categoryFilters[category] || [];
        console.log('applicableNames', applicableNames);
        // Filter with partial matches
        const filteredData = sortedData.filter((pkg) =>
          applicableNames.some((name) =>
            pkg.portfolioName.toLowerCase().includes(name.toLowerCase())
          )
        );

        console.log('Filtered Data:', filteredData);
        setPackagesData(filteredData);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching packages:', err);
        setLoading(false);
      }
    };

    fetchData();
  }, [category, name]);

  useEffect(() => {
    setFilteredPackages(() => {
      const categoryFilters = {
        'x-Blue': [
          'Smart Crypto Ripple',
          'Smart Crypto Surge',
          'Smart Crypto Wave',
        ],
        'x-Bitcoin': [
          'xBitcoin Blooming',
          'xBitcoin Bull-Run',
          'xBitcoin Rush',
        ],
      };

      const applicableNames = categoryFilters[category] || [];
      console.log(details?.name, 'applicablenames');
      // Filter with partial matches
      const filteredByCategory = packagesData.filter((pkg) =>
        applicableNames.some((name) =>
          pkg.portfolioName.toLowerCase().includes(name.toLowerCase())
        )
      );

      // Filtering logic based on selectedInnerTab
      return filteredByCategory.filter((pkg) =>
        pkg.portfolioName.includes(details?.name)
      );
    });
  }, [details, packagesData, category, name]);
  const isAuthenticated = localStorage.getItem('access_token') !== null;

  const handleViewAllocation = (allocationData) => {
    requireAuth(() => {
      setSelectedAllocation(allocationData);
      setAllocationPopup(true);
    });
  };

  const handleClickBuyPlan = (allocationData) => {
    requireAuth(() => {
      setSelectedAllocation(allocationData);
      if (isWebinarUser) setShowDemoPopup2(true);
      else setCreateAPlanPopup(true);
    });
  };

  const openSubscriptionSelector = () => {
    setSubscriptionSelectorOpen(true);
  };

  const handleStartSubscription = (pkg) => {
    requireAuth(() => {
      setSubscriptionPackage(pkg);
      setSubscriptionPlanLabel(getPlanLabel(pkg?.portfolioName));
      setSubscriptionMethodMessage('');
      setSubscriptionSelectorOpen(true);
    });
  };

  const handleSubscriptionPopupClose = () => {
    setSubscriptionPopupOpen(false);
    setSubscriptionPackage(null);
  };

  const handleSubscriptionPlanSelect = (pkg) => {
    setSubscriptionPackage(pkg);
    setSubscriptionPlanLabel(getPlanLabel(pkg?.portfolioName));
    setSubscriptionMethodMessage('');
    setSubscriptionSelectorOpen(false);
    setSubscriptionPopupOpen(true);
  };

  const handleSubscriptionPaymentMethodSelect = async (method) => {
    const planLabel = subscriptionPlanLabel || 'Smart Crypto plan';
    const paypalMethods = ['Paypal', 'Credit Card'];
    const manualMethods = [
      'ACH',
      'Wire Transfer',
      'Zelle',
      'TygaPay',
      'Venmo',
    ];
    let followUpText =
      'Our team will reach out with the next steps for this automatic plan.';
    if (paypalMethods.includes(method)) {
      followUpText =
        'You will be redirected to PayPal for the first charge, and the subscription renews monthly.';
    } else if (manualMethods.includes(method)) {
      followUpText =
        'ACH, wire, and similar methods are handled manually—send the funds and notify us so we can activate the recurring subscription.';
    } else if (method === 'USD') {
      followUpText =
        'We will debit the USD balance; if there are insufficient funds the team will reach out with next steps.';
    } else if (method === 'Asset Wallet') {
      followUpText =
        'The asset wallet will be debited automatically and we will reach out if anything requires manual follow-up.';
    }

    const baseMessage = `${planLabel} subscription via ${method}. ${followUpText}`;
    setSubscriptionMethodMessage(baseMessage);

    if (!subscriptionPackage) {
      return;
    }

    try {
      const token = localStorage.getItem('access_token');
      const decodedToken = decodeJWT(String(token || '')) || {};
      const currentTimeSeconds = Math.floor(Date.now() / 1000);
      if (decodedToken?.exp && decodedToken.exp <= currentTimeSeconds) {
        const expiryText =
          'Session expired. You will be logged out in 10 seconds.';
        setSubscriptionMethodMessage(
          'Session expired. Please log in again to continue with Smart Crypto subscriptions.'
        );
        setTokenExpiredMessage(expiryText);
        setTokenExpiredPopupOpen(true);
        return;
      }
      const email =
        decodedToken?.email ??
        decodedToken?.userEmail ??
        decodedToken?.sub ??
        localStorage.getItem('email') ??
        '';

      if (!email) {
        setSubscriptionMethodMessage(
          `${planLabel} subscription via ${method}. Unable to determine your email address—please log in again.`
        );
        return;
      }

      const planId =
        subscriptionPackage.planId ??
        subscriptionPackage.planCode ??
        subscriptionPackage._id ??
        subscriptionPackage.id ??
        subscriptionPackage.portfolioId ??
        planLabel ??
        '';

      const payload = {
        email,
        planId,
        amount: getSubscriptionAmount(subscriptionPackage),
        currency: subscriptionPackage?.currency ?? 'USD',
        paymentMethod: method,
        paymentReference: '',
        returnUrl: window.location.href,
        cancelUrl: window.location.href,
        portfolioName: planLabel,
        managedBy:
          subscriptionPackage.managedBy || subscriptionPackage?.manager || 'Smart Crypto Team',
        notes: `Selected via Smart Crypto subscription modal (${method}).`,
      };

      const response = await createSmartCryptoSubscription(payload);
      const approvalUrl =
        response?.approvalUrl ??
        response?.data?.approvalUrl ??
        response?.links?.find((link) => link.rel?.includes('approve'))?.href ??
        response?.data?.links?.find((link) =>
          String(link?.rel).includes('approve')
        )?.href;
      const responseMessage =
        response?.message ??
        response?.data?.message ??
        (response?.status === 'success' ? 'Subscription saved.' : '');

      if (approvalUrl) {
        window.open(approvalUrl, '_blank');
      }

      const extraMessage = approvalUrl
        ? 'Approve the payment in the new tab to complete your subscription.'
        : responseMessage;

      if (extraMessage) {
        setSubscriptionMethodMessage((prev) => `${prev} ${extraMessage}`);
      }
    } catch (error) {
      console.error('Subscription creation error', error);
      setSubscriptionMethodMessage(
        `${planLabel} subscription via ${method}. Unable to contact the backend—please try again soon.`
      );
    }
  };

  const getImage = (image) => {
    try {
      if (image === 'INEX') {
        return Inex;
      } else {
        return require(`../../../assets/token-icons/${image}.png`).default;
      }
    } catch (error) {
      return Inex;
    }
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleBlueCard = (planName = 'ripple') => {
    setSelectedCategory('x-Blue');
    setPlanDetailPopupOpen(true);
    setSelectedPlanName(planName);
  };

  const handleYellowCard = (planName = 'blooming') => {
    setSelectedCategory('x-Bitcoin');
    setPlanDetailPopupOpen(true);
    setSelectedPlanName(planName);
  };

  const xBlueplanDetails = [
    {
      image: ripple,
      name: 'Ripple',
      description: 'Designed for stability and stable returns',
      path: '/smart-crypto/plan-detail/ripple',
    },
    {
      image: surge,
      name: 'Surge',
      description: 'Moderate volatility, consistent returns.',
      path: '/smart-crypto/plan-detail/surge',
    },
    {
      image: wave,
      name: 'Wave',
      description: ' High volatility, high potential rewards.',
      path: '/smart-crypto/plan-detail/wave',
    },
  ];

  const xBitcoinplanDetails = [
    {
      image: bloomingIcon,
      name: 'Blooming',
      description: 'Optimized for low volatility and steady performance.',
      path: '/smart-crypto/plan-detail/blooming',
    },
    {
      image: rushIcon,
      name: 'Rush',
      description: 'Moderate volatility, consistent returns',
      path: '/smart-crypto/plan-detail/rush',
    },
    {
      image: bullRunIcon,
      name: 'Bull-Run',
      description: 'High volatility, high potential returns.',
      path: '/smart-crypto/plan-detail/bull-run',
    },
  ];

  const handleHeader = () => {
    navigate(`/smart-crypto?id=get-to-know`);
  };

  const planDetails =
    category === 'x-Blue' ? xBlueplanDetails : xBitcoinplanDetails;
  const effectiveCategory = category || 'x-Blue';
  const planLabel = effectiveCategory === 'x-Blue' ? 'x-Blue' : 'x-Bitcoin';
  const planLogo = planLabel === 'x-Blue' ? xBlueIcon : xBitcoinIcon;
  const planAccentColor = planLabel === 'x-Blue' ? '#07A6FC' : '#FBB002';
  const subscriptionHeroTitleText = `What ${planLabel} subscribers receive each month`;
  const subscriptionHeroSubtitleText =
    planLabel === 'x-Blue'
      ? 'Altcoin-focused research, rebalancing guidance, and alerts tuned to fast-moving markets.'
      : 'Bitcoin-anchored research, tactical alt exposure, and stability-focused alerts.';
  const subscriptionHeroDescription =
    planLabel === 'x-Blue'
      ? 'A diversified alt-focused approach with roughly 80% altcoins and disciplined volatility controls.'
      : 'A Bitcoin-led strategy with ~60% BTC and 40% curated alt selections for balanced growth.';
  const subscriptionAmount = getSubscriptionAmount(subscriptionPackage);
  const subscriptionOptions = subscriptionPlans;
  return (
    <div className={classes.root}>
      <IconicHeader selectedTab={selectedTab} onChange={handleTabChange} />
      <div className={classes.header}>
        <PlanIconicHeader
          selectedPlanTab={selectedPlanTab}
          setSelectedPlanTab={(val) => {
            if (val === 1) {
              setCategory('x-Bitcoin');
              setName('blooming');
            } else {
              setCategory('x-Blue');
              setName('ripple');
            }
            setSelectedPlanTab(val);
          }}
          largeFont={true}
        />


        <div className={classes.flexContainertwo}>
          {selectedPlan.map((curr) => (
            <div
              className={`${classes.flexContainer1} ${
                name === curr.name.toLowerCase() && classes.activePlan
              }`}
              onClick={() => setName(curr.name.toLowerCase())}
            >
              <img src={curr?.img} alt="" />
              <h2>{curr?.name}</h2>
              {name === curr.name.toLowerCase() && (
                <div className={classes.activeBar}></div>
              )}
            </div>
          ))}
        </div>

        <p>{details?.description}</p>
        <div className={classes.subscriptionCallout}>
          <GenericButton
            text="More details about monthly subscriptions"
             className={
                    category === 'x-Blue'
                      ? classes.blueButton
                      : classes.yellowButton
                  }
            onClick={openSubscriptionSelector}
          />
        </div>
      </div>

      {subscriptionMethodMessage && (
        <div className={classes.subscriptionInstruction}>
          {subscriptionMethodMessage}
        </div>
      )}

      <div className={classes.cardWrapper}>
        {loading ? (
          <p>Loading...</p>
        ) : filteredPackages?.length > 0 ? (
          filteredPackages?.map((pkg) => (
            <div key={pkg._id} className={classes.cardContainer}>
              <h3>
                {pkg.portfolioName.includes('Smart Crypto Ripple') &&
                  'x-Blue Ripple'}
                {pkg.portfolioName.includes('Smart Crypto Wave') &&
                  'x-Blue Wave'}
                {pkg.portfolioName.includes('Smart Crypto Surge') &&
                  'x-Blue Surge'}
                {pkg.portfolioName.includes('xBitcoin Blooming') &&
                  'x-Bitcoin Blooming'}
                {pkg.portfolioName.includes('xBitcoin Bull-Run') &&
                  'x-Bitcoin Bull-Run'}
                {pkg.portfolioName.includes('xBitcoin Rush') &&
                  'x-Bitcoin Rush'}
                ({pkg?.managedBy})
              </h3>
              <p>
                {pkg.portfolioName.includes('Smart Crypto Ripple') &&
                  'Less Volatility'}
                {pkg.portfolioName.includes('Smart Crypto Wave') &&
                  'High Volatility, Mid Return On Investment(ROI)'}
                {pkg.portfolioName.includes('Smart Crypto Surge') &&
                  'Mid Level Volatility, Mid Return On Investment(ROI)'}
                {pkg.portfolioName.includes('xBitcoin Blooming') &&
                  'High Performance Portfolio'}
                {pkg.portfolioName.includes('xBitcoin Bull-Run') &&
                  'Aggressive Growth Portfolio'}
                {pkg.portfolioName.includes('xBitcoin Rush') &&
                  'Diverse Crypto Portfolio'}
              </p>
              <div className={classes.flexContainer}>
                <div style={{ margin: '10px 0px' }}>
                  <p>Assets</p>
                  <AvatarGroup max={4}>
                    {pkg.cryptocurrencies.map((crypto) => (
                      <Avatar
                        key={crypto._id}
                        alt={crypto.name}
                        src={getImage(crypto?.token)}
                      />
                    ))}
                  </AvatarGroup>
                </div>
              </div>
              <div className={classes.cardDescription}>
                <h4>Description:</h4>
                <p>{pkg?.description}</p>
              </div>
              <div className={classes.buttonContainer}>
                <GenericButton
                  text="View Allocation"
                  className={classes.greyButton}
                  onClick={() => handleViewAllocation(pkg)}
                />
                <GenericButton
                  text="Start Plan"
                  className={
                    category === 'x-Blue'
                      ? classes.blueButton
                      : classes.yellowButton
                  }
                  onClick={() => handleClickBuyPlan(pkg)}
                />
                <GenericButton
                  text="Start Subscription"
                  className={
                    category === 'x-Blue'
                      ? classes.blueButton
                      : classes.yellowButton
                  }
                  onClick={() => handleStartSubscription(pkg)}
                />
              </div>
            </div>
          ))
        ) : (
          <p>No packages found.</p>
        )}
      </div>

      <div className={classes.createOwnPlan}>
        <h3>Create your own plan</h3>
        <p>
          Create a smart crypto plan to boost your autopilot, hands-off
          investment vehicle
        </p>

        <div className={classes.cardContainer}>
          <h3>Can’t find a plan you like?</h3>
          <div className={classes.flexContainer}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
              }}
            >
              <p style={{ marginBottom: '10px' }}>
                Choose and create your own plan!
              </p>
              <AvatarGroup max={8} sx={{ marginBottom: '10px' }}>
                {allTokens?.map((crypto) => (
                  <Avatar
                    key={crypto._id}
                    alt={crypto.name}
                    src={getImage(crypto?.image)}
                  />
                ))}
              </AvatarGroup>
            </div>
          </div>
          <div className={classes.cardDescription}>
            <h4>Description:</h4>
            <p>
              Customize strategies to achieve your goals and take control of
              your investment.
            </p>
          </div>
          <div className={classes.buttonContainer}>
            <GenericButton
              text="Create your own plan!"
              className={
                category === 'x-Blue'
                  ? classes.blueButton
                  : classes.yellowButton
              }
              onClick={() => {
                requireAuth(() => {
                  setCreateOwnPlan(true);
                });
              }}
            />
          </div>
        </div>
      </div>

      {showDemoPopup2 && isWebinarUser && (
        <DemoInvestmentPopup2
          isWebinarUser={isWebinarUser}
          onClose={() => {
            setShowDemoPopup2(false);
            setCreateAPlanPopup(true);
          }}
        />
      )}
      {/* <div className={classes.exploreContainer}>
        <h3>Explore {category}</h3>
        <div className={classes.absoluteImg}>
          <img src={category === 'x-Blue' ? xBlueBg : xBitcoinBg} alt="" />
        </div>
        <div className={classes.exploreBgContainer}>
          <div className={classes.contentContainer}>
            {planDetails.map((curr) => (
              <div className={classes.planCardRoot}>
                <img src={curr.image} />
                <h4>{curr.name}</h4>
                <p>{curr.description}</p>
                <GenericButton
                  text="View Package"
                  className={
                    category === 'x-Blue'
                      ? classes.blueButton
                      : classes.yellowButton
                  }
                  onClick={() => {
                    navigate(curr.path);
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={classes.cardRoot}>
        <h3>Get to know Smart Crypto</h3>
        <p>We offers two exclusive strategies, x-Blue, x-Bitcoin </p>
        <div className={classes.cardContainerOne}>
          <div className={classes.card}>
            <div className={classes.imgContainer}>
              <img src={xBlueIcon} />
              <span>x-Blue</span>
            </div>
            <p>
              With over 80% altcoins and less than 20% Bitcoin, this offers a
              diverse range of cryptocurrencies for your investment, allowing
              you to stay in tune with the heartbeat of the crypto industry.
            </p>

            <div className={classes.smallCardContainer}>
              <div
                className={`${classes.smallCard} ${classes.blueSmCardHover}`}
                onClick={() => handleBlueCard('ripple')}
              >
                <img src={ripple} />
                <span>Ripple</span>
              </div>

              <div
                className={`${classes.smallCard} ${classes.blueSmCardHover}`}
                onClick={() => handleBlueCard('surge')}
              >
                <img src={surge} />
                <span>Surge</span>
              </div>

              <div
                className={`${classes.smallCard} ${classes.blueSmCardHover}`}
                onClick={() => handleBlueCard('wave')}
              >
                <img src={wave} />
                <span>Wave</span>
              </div>
            </div>

            <div
              className={classes.plusContainer}
              onClick={() => handleBlueCard()}
            >
              <img src={plusIcon} />
            </div>
          </div>

          <div className={classes.card}>
            <div className={classes.imgContainer}>
              <img src={xBitcoinIcon} />
              <span>x-Bitcoin</span>
            </div>
            <p>
              A portfolio consisting of 60% Bitcoin and 40% altcoins offers a
              balanced approach, combining the stability of Bitcoin with the
              growth potential of altcoins.
            </p>

            <div className={classes.smallCardContainer}>
              <div
                className={`${classes.smallCard} ${classes.yellowSmCardHover}`}
                onClick={() => handleYellowCard('blooming')}
              >
                <img src={bloomingIcon} />
                <span>Blooming</span>
              </div>

              <div
                className={`${classes.smallCard} ${classes.yellowSmCardHover}`}
                onClick={() => handleYellowCard('rush')}
              >
                <img src={rushIcon} />
                <span>Rush</span>
              </div>

              <div
                className={`${classes.smallCard} ${classes.yellowSmCardHover}`}
                onClick={() => handleYellowCard('bull-run')}
              >
                <img src={bullRunIcon} />
                <span>Bull-Run</span>
              </div>
            </div>

            <div
              className={classes.plusContainer}
              onClick={() => handleYellowCard()}
            >
              <img src={plusIcon} />
            </div>
          </div>
        </div>
      </div> */}

      {allocationPopop && (
        <AllocationPopup
          onClose={() => setAllocationPopup(false)}
          category={category}
          allocationData={selectedAllocation}
          onStartPopup={(pkg) => handleClickBuyPlan(pkg)}
        />
      )}

      {createAPlanPopop && (
        <CreateAPlanPopup
          onClose={() => setCreateAPlanPopup(false)}
          category={category}
          allocationData={selectedAllocation}
          isWebinarUser={isWebinarUser}
          isFreeTrialUpgrade={isFreeTrialUpgrade}
        />
      )}
      {createOwnPlan && (
        <CreateOwnPlan
          onClose={() => setCreateOwnPlan(false)}
          category={category}
          filteredTokens={allTokens}
        />
      )}
      {subscriptionSelectorOpen && (
        <div className={classes.subscriptionOverlay}>
          <div className={classes.subscriptionModal}>
            <div className={classes.subscriptionModalHeader}>
              <div>
                <h3 style={{ margin: 0 }}>
                  Monthly Research + Model Portfolio Updates
                </h3>
                <p style={{ margin: '4px 0 0', color: '#888' }}>
                  Choose the tier that matches your monthly commitment.
                </p>
              </div>
              <CloseIcon
                onClick={() => setSubscriptionSelectorOpen(false)}
                sx={{ cursor: 'pointer' }}
              />
            </div>
            <div
              className={classes.subscriptionModalHero}
              style={{ borderBottomColor: planAccentColor }}
            >
              <div className={classes.subscriptionHeroBranding}>
                <img
                  src={planLogo}
                  alt={`${planLabel} logo`}
                  className={classes.subscriptionHeroLogo}
                />
                <div className={classes.subscriptionHeroBrandingText}>
                  <p className={classes.subscriptionHeroBrandingTitle}>
                    Smart Crypto {planLabel}
                  </p>
                  <p className={classes.subscriptionHeroBrandingSubtitle}>
                    {subscriptionHeroDescription}
                  </p>
                </div>
              </div>
              <span
                className={classes.subscriptionHeroBadge}
                style={{ background: planAccentColor, color: '#000' }}
              >
                {`${planLabel} strategy`}
              </span>
              <h3 className={classes.subscriptionHeroTitle}>
                {subscriptionHeroTitleText}
              </h3>
              <p className={classes.subscriptionHeroSubtitle}>
                {subscriptionHeroSubtitleText}
              </p>
            </div>
            <div className={classes.detailInfoSection}>
              <p>
                Each monthly subscription brings curated research, disciplined
                risk rules, and an updated model portfolio with clear guidance
                on how to size positions and monitor regime shifts.
              </p>
              <ul className={classes.detailInfoList}>
                <li className={classes.detailInfoItem}>
                  Dedicated research updates covering when and why allocations
                  changed.
                </li>
                <li className={classes.detailInfoItem}>
                  Alerts for major trend breaks and risk thresholds, optional
                  but recommended.
                </li>
                <li className={classes.detailInfoItem}>
                  PayPal/credit card unlock the automated first charge. ACH or
                  wire requires manual confirmation with the team.
                </li>
              </ul>
              <p className={classes.detailInfoNote}>
                Need more help? Reach out to support to review the strategy before
                subscribing.
              </p>
            </div>
            {subscriptionPlanError && (
              <p className={classes.detailInfoNote}>{subscriptionPlanError}</p>
            )}
            {subscriptionPlansLoading && subscriptionOptions.length === 0 ? (
              <p>Loading monthly subscription plans...</p>
            ) : subscriptionOptions.length === 0 ? (
              <p>No subscription plans are available right now.</p>
            ) : (
              <>
                <div className={classes.featuresSection}>
                  <h4 className={classes.featuresSectionTitle}>
                    What you get each month
                  </h4>
                  <p className={classes.featuresSectionSubTitle}>
                    Monthly research, alerts, and explanations designed to keep
                    you synchronized with the model portfolio.
                  </p>
                  <div className={classes.featuresGrid}>
                    {subscriptionFeatures.map((feature) => (
                      <div key={feature.title} className={classes.featureCard}>
                        <div
                          className={classes.featureIcon}
                          style={{ background: planAccentColor }}
                        ></div>
                        <div className={classes.featureText}>
                          <p className={classes.featureTitle}>{feature.title}</p>
                          <p className={classes.featureDescription}>
                            {feature.description}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className={classes.monthlyPlansFooter}>
                  <div className={classes.monthlyCardsWrapper}>
                    {subscriptionOptions.map((pkg) => {
                      const amount = getSubscriptionAmount(pkg);
                      return (
                        <div
                          key={`selector-${pkg._id}`}
                          className={classes.subscriptionCard}
                        >
                          <p className={classes.subscriptionCardTitle}>
                            {getPlanLabel(pkg?.portfolioName)}
                          </p>
                          <div
                            className={classes.subscriptionCardPrice}
                            style={{ color: planAccentColor }}
                          >
                            {amount ? `$${amount}` : '—'}
                          </div>
                          <div className={classes.subscriptionCardPerMonth}>
                            per month
                          </div>
                          <p className={classes.subscriptionCardDescription}>
                            Includes: model portfolio + monthly updates + alerts
                          </p>
                          <GenericButton
                            text="Continue to Payment"
                            className={
                              category === 'x-Blue'
                                ? classes.blueButton
                                : classes.yellowButton
                            }
                            onClick={() => handleSubscriptionPlanSelect(pkg)}
                          />
                        </div>
                      );
                    })}
                  </div>
                  <p className={classes.detailInfoNote}>
                    Monthly subscriptions currently support PayPal and Credit
                    Card only.
                  </p>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {subscriptionPopupOpen && (
        <PaymentPopup
          open={subscriptionPopupOpen}
          onClose={handleSubscriptionPopupClose}
          amount={subscriptionAmount}
          onSelectPaymentMethod={handleSubscriptionPaymentMethodSelect}
          type="Buy"
          token={{ title: 'USD' }}
          spendToken={null}
          category={category}
          subscriptionMode
        />
      )}
      {planDetailPopupOpen && (
        <DetailPopup
          category={selectedCategory}
          onClose={() => setPlanDetailPopupOpen(false)}
          planName={selectedPlanName}
        />
      )}
      {tokenExpiredPopupOpen && (
        <GeneralPopup
          message={tokenExpiredMessage}
          onClose={() => {
            setTokenExpiredPopupOpen(false);
            handleTokenExpiryLogout();
          }}
          width={tokenExpiredMessage.length > 100 ? '600px' : '360px'}
        />
      )}
      {showLoginPopup && <LoginRequiredPopup onClose={handleLoginPopupClose} />}
    </div>
  );
};

export default PlanDetails;
